import { Pagination } from "@mui/material";
import { useRef } from "react";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IRydeTable,
  IStyledAttributes,
  ITableDto,
} from "@ryde/shared";

import { usePagingStickyEmulationReports } from "./hooks";

interface IGridPagingReports {
  table: IRydeTable<ITableDto>;
}

const GridPagingContainerReportsStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "grid-paging-container-reports",
})`
  margin-top: 10px;
  margin-bottom: 10px;
  margin-inline-end: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  bottom: 15px;
  height: 32px;
`;

export const GridPagingReports = ({
  table,
}: IGridPagingReports): JSX.Element => {
  const pagingRef = useRef<HTMLDivElement>(null);
  const { pagination } = table.state;

  const handlePagerChange = (
    e: React.ChangeEvent<unknown>,
    value: number,
  ): void => {
    table.setPageIndex(value - 1);
  };

  usePagingStickyEmulationReports({ pagingRef });
  return (
    <GridPagingContainerReportsStyled ref={pagingRef}>
      {pagination && (
        <Pagination
          page={pagination.pageIndex + 1}
          count={table.getPageCount()}
          onChange={handlePagerChange}
        />
      )}
    </GridPagingContainerReportsStyled>
  );
};
